import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {PlannerBoardActivityCardTextDisplayType} from 'app/blocks/model/enums/planner-board-activity-card-text-display-type';
import {PlannerBoardCardType} from 'app/blocks/model/enums/planner-board-card-type.enum';
import {PlannerBoardCard} from 'app/blocks/model/planner-board/planner-board-card';

export interface IPlannerBoardActivityCardType extends IBaseEntity {
    id: number;
    name: string;
    backgroundColor: string;
    fontColor: string;
    textDisplayType: PlannerBoardActivityCardTextDisplayType;
    getPlannerCardPreview();
}

export class PlannerBoardActivityCardType extends BaseEntity implements IPlannerBoardActivityCardType {
    private readonly CARD_PREVIEW_TEXT = 'Input Text';
    constructor(activityType?: any) {
        super();
        if (!activityType) {
            return;
        }

        this.id = activityType.id;
        this.name = activityType.name;
        this.backgroundColor = activityType.backgroundColor;
        this.fontColor = activityType.fontColor;
        if (activityType.textDisplayType && typeof activityType.textDisplayText === 'string') {
            this.textDisplayType = PlannerBoardActivityCardTextDisplayType[PlannerBoardActivityCardTextDisplayType[activityType.textDisplayType]];
        } else {
            this.textDisplayType = activityType.textDisplayType;
        }
    }

    id: number;
    name: string;
    backgroundColor: string;
    fontColor: string;
    textDisplayType: PlannerBoardActivityCardTextDisplayType;

    getPlannerCardPreview() {
        const plannerBoardCardType = this;

        const pbCard = new PlannerBoardCard();
        pbCard.activityText = this.CARD_PREVIEW_TEXT;
        pbCard.activityType = plannerBoardCardType;
        pbCard.cardType = PlannerBoardCardType.ACTIVITY;

        return pbCard;
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): PlannerBoardActivityCardType {
        return new PlannerBoardActivityCardType(this);
    }
}
